<template>
  <div>
    <HeroSection />
    <FeaturesSection />
    <ExtensionSection />
    <HowItWorksSection />
    <CtaSection />
  </div>
</template>

<script>
  import HeroSection from './HeroSection.vue'
  import FeaturesSection from './FeaturesSection.vue'
  import ExtensionSection from './ExtensionSection.vue'
  import HowItWorksSection from './HowItWorksSection.vue'
  import CtaSection from './CtaSection.vue'
  import { fadeUpMixin } from '../composables/useFadeUp.js'

  export default {
    name: 'HomePage',
    components: { HeroSection, FeaturesSection, ExtensionSection, HowItWorksSection, CtaSection },
    mixins: [fadeUpMixin],
  }
</script>
